module.exports = __webpack_public_path__ + "static/img/3.b3e83849.png";